import { colors } from "../../../global";

const EffortSummaryTable = ({ rows = [] }) => {
  const totalTickets = rows.reduce(
    (s, r) => s + Number(r.ticket_count || 0),
    0
  );

  const totalHours = rows.reduce((s, r) => s + Number(r.total_times || 0), 0);

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
      <div className="overflow-x-auto">
        <table className="w-full border-collapse text-sm">
          <thead>
            <tr style={{ backgroundColor: colors.primary }}>
              <th className="py-3 px-4 text-left text-white font-semibold text-xs uppercase tracking-wide">
                Effort
              </th>
              <th className="py-3 px-4 text-left text-white font-semibold text-xs uppercase tracking-wide">
                Tickets
              </th>
              <th className="py-3 px-4 text-left text-white font-semibold text-xs uppercase tracking-wide">
                Total Time (hrs)
              </th>
            </tr>
          </thead>

          <tbody>
            {rows.map((row, i) => {
              const tickets = Number(row.ticket_count || 0);
              const times = Number(row.total_times || 0);

              return (
                <tr
                  key={i}
                  className="border-b border-gray-200 hover:bg-gray-50 transition-colors"
                >
                  <td
                    className="py-3 px-4 font-medium"
                    style={{ color: colors.primary }}
                  >
                    {row.Effort}
                  </td>

                  <td className="py-3 px-4" style={{ color: colors.secondary }}>
                    {tickets.toLocaleString()}
                  </td>

                  <td className="py-3 px-4" style={{ color: colors.secondary }}>
                    {times.toFixed(1)} hrs
                  </td>
                </tr>
              );
            })}

            {/* ===== REPORT TOTAL ===== */}
            <tr style={{ backgroundColor: `${colors.primary}10` }}>
              <td
                className="py-4 px-4 font-bold"
                style={{ color: colors.primary }}
              >
                Report Total
              </td>

              <td
                className="py-4 px-4 font-bold"
                style={{ color: colors.primary }}
              >
                {totalTickets.toLocaleString()}
              </td>

              <td
                className="py-4 px-4 font-bold"
                style={{ color: colors.primary }}
              >
                {totalHours.toFixed(1)} hrs
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default EffortSummaryTable;
